/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC } from 'react'
import { useIntl } from 'react-intl'
import { PageTitle } from '../../../_metronic/layout/core'
import { NavLink } from 'react-router-dom'
import { hexColorValue } from 'docx'
import { colorDarken } from '../../../_metronic/assets/ts/_utils'
import { AccountStatusesBba } from '../../modules/accountStatuses/AccountStatusesBba'



const AccountStatusesPage: FC = () => (
    <>

        <div className='row gy-5 g-xl-8'>
            <AccountStatusesBba className='card-xxl-stretch' />
        </div>
        {/* end::Row */}
    </>
)

const AccountStatusesBbaWrapper: FC = () => {
    const intl = useIntl()
    return (
        <>
            <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.STATUSES' })}</PageTitle>
            <AccountStatusesPage />
        </>
    )
}

export { AccountStatusesBbaWrapper }
